<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="paddingContent">
      <div class="ListMenu">
        <el-form ref="form" :model="listMenuForm" class="searchForm">
          <el-form-item label="搜索條件">
            <el-select v-model="searchBlock" placeholder="請選擇">
              <el-option label="溯源碼" value="1"></el-option>
              <el-option label="商品名稱" value="2"></el-option>
              <el-option label="綁定帳號" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="searchBlock === '2' && goodsNameArray.length > 0" label="關鍵字">
            <el-select v-model="goodsNameValue" placeholder="請選擇">
              <el-option v-for="(name, index) in goodsNameArray"
              style="width: 200px;" 
              :key="index" :label="name" :value="name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-else label="關鍵字">
            <el-input
              v-model="listMenuForm.keyword"
              placeholder="請輸入搜索內容"
            ></el-input>
          </el-form-item>
          <el-form-item label="綁定時間">
            <el-date-picker
              v-model="listMenuForm.bindingTime"
              type="date"
              placeholder="請選擇綁定時間"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="狀態">
            <el-select v-model="statusBlock" placeholder="请选择">
              <el-option label="已綁定" value="1"></el-option>
              <el-option label="未綁定" value="0"></el-option>
              <el-option label="已作廢" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="MenuBtnWrap">
        <div class="btn" @click="search()">查詢</div>
        <div class="btn borderBtn" @click="reset()">重置</div>
      </div>
      <div class="tableWrap mergeTable">
        <el-table
          :data="goodsList"
          border
          height='660px'
          style="width:100%;"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in goodsTable" :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width">
            <template slot-scope="scope">
              <div
                v-if="item.prop === 'username'"
                :style="{ color: '#6C3DEA', cursor: 'pointer' }"
                @click="
                  if (scope.row.username !== '-') {
                    $router.push(
                      '/userDetails?id=' + scope.row.userId + '&status=originCode'
                    )
                  }
                "
              >
                {{ scope.row.username }}
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" :width="300">
            <template slot-scope="scope">
              <el-button
                class="topBtn"
                @click="initOrigin(scope.row, 2)"
                :disabled="scope.row.status == '已綁定' || scope.row.status == '已作廢'"
                type="text"
              >綁定</el-button>
              <el-button
                class="topBtn"
                @click="initOrigin(scope.row, 1)"
                :disabled="scope.row.status == '未綁定'"
                type="text"
              >初始</el-button>
              <el-button
                class="topBtn"
                @click="initOrigin(scope.row, 4)"
                :disabled="scope.row.status == '已作廢'"
                type="text"
              >作廢</el-button>
              <el-button
                class="topBtn"
                @click="$router.push('/editMemberGoods?id='+scope.row.id)"
                type="text"
              >詳情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count='5'
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar';

export default {
  data () {
    return {
      navBlock: '商城',
      navtitle: '溯源碼列表',
      goodsList:[],
      searchBlock: '1',
      statusBlock: '1',
      listMenuForm: {
        keyword: "",
        bindingTime: ""
      },
      goodsTable: [
        {
          prop: 'tracingSourceCode',
          label: '溯源碼',
          width: ''
        },{
          prop: 'status',
          label: '狀態',
          width: '100'
        },{
          prop: 'goodsName',
          label: '商品名稱',
          width: ''
        },{
          prop: 'bindingTime',
          label: '綁定時間',
          width: ''
        },{
          prop: 'username',
          label: '綁定帳號',
          width: ''
        }, {
          prop: 'bindingCount',
          label: '被綁定次數',
          width: '100'
        }
      ],
      total: 0,
      currentPage: 1,
      goodsNameArray: [],
      goodsNameValue: '',
    }
  },
  created(){
    this.initList();
    this.getGoodsNameData();
  },
  activated(){
    if(this.currentPage===1){
      this.initList();
      this.getGoodsNameData();
    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  watch: {
    searchBlock(newValue, oldValue) {
      this.listMenuForm.keyword = '';
      this.listMenuForm.bindingTime = '';
      this.goodsNameValue = '';
    }
  },
  methods:{
    // 初始化商品列表
    initList(){
      let tracingSourceCodeValue = this.searchBlock == '1' ? this.listMenuForm.keyword : '';
      let titleValue = this.searchBlock == '2' ? this.goodsNameValue : '';
      let usernameValue = this.searchBlock == '3' ? this.listMenuForm.keyword : '';
      let statusValue = this.statusBlock ? Number(this.statusBlock) : '';
      let bindingTimeValue = this.listMenuForm.bindingTime ? this.$formatDate(this.listMenuForm.bindingTime) : '';
      this.$get(`/request/tracing/source/list?page=${this.currentPage}&size=10&tracingSourceCode=${tracingSourceCodeValue}&title=${titleValue}&username=${usernameValue}&status=${statusValue}&bindingTime=${bindingTimeValue}`, this.$GLOBAL.jsonConfig)
      .then((res) => {
        // console.log(res);
        if(res.code==='00000') {
          res.data.list.sort().reverse().forEach(v => {
            v.bindingTime = v.bindingTime ? this.$getTime(v.bindingTime) : '-';
            v.username = v.username ? v.username : '-';
            switch (v.status) {
              case 0:
                v.status = '未綁定'
                break
              case 1:
                v.status = '已綁定'
                break
              case 2:
                v.status = '已作廢'
                break
            }
          });
          this.goodsList = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            center: true
          });
        }
      })
    },
    // 商品名称数据
    getGoodsNameData() {
      this.$get('/request/tracing/source/goods/name/list', this.$GLOBAL.jsonConfig)
      .then(res => {
        // console.log(res);
        if (res.code === '00000') {
          this.goodsNameArray = res.data.list;
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            center: true
          });
        }
      })
    },
    //数据数量选择
    handleCurrentChange(val){
      this.currentPage = val;
      this.initList();
    },
    // 查询
    search() {
      this.initList();
    },
    // 重置
    reset() {
      this.currentPage = 1;
      this.searchBlock = '1';
      this.listMenuForm.keyword = '';
      this.statusBlock = '1';
      this.listMenuForm.bindingTime = '';
      this.goodsNameValue = '';
      this.initList();
    },
    // 初始/作廢
    initOrigin(row, type) {
      let noticeContent = '';
      let message = '';
      if (type === 1) {
        if (row.username && row.username !== '-') {
          noticeContent = `是否初始化該數據？溯源碼：${row.tracingSourceCode}，當前綁定帳號：${row.username}`;
        } else {
          noticeContent = `是否初始化該數據？溯源碼：${row.tracingSourceCode}`;
        }
        message = '初始化成功';
      } else if (type === 4) {
        if (row.username && row.username !== '-') {
          noticeContent = `溯源碼：${row.tracingSourceCode}，當前綁定帳號：${row.username}，是否作廢該溯源碼？`;
        } else {
          noticeContent = `溯源碼：${row.tracingSourceCode}，是否作廢該溯源碼？`;
        }
        message = '作廢成功';
      }

      if (type === 2) {
        this.$prompt('請輸入綁定帳號：', '', {
          inputPlaceholder: '請輸入綁定人帳號',
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          showClose: false,
          center: false,
          closeOnClickModal: false
          // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          // inputErrorMessage: '邮箱格式不正确'
        }).then(({ value }) => {
          if (!value) {
            this.$message({
              message: '請輸入綁定帳號',
              type: 'error',
              center: true
            });
            return;
          }
          let params = {
            id: row.id,
            operate: type,
            username: value
          }
          this.$post('/request/tracing/source/operate', params, this.$GLOBAL.jsonConfig)
          .then(res => {
            // console.log(res)
            if (res.code === '00000') {
              this.$message({
                message: '綁定成功',
                type: 'success',
                center: true
              });
              this.initList();
            } else {
              this.$message({
                message: res.message,
                type: 'error',
                center: true
              });
            }
          })
        });
      } else {
        this.$confirm(noticeContent, {
          showClose: false,
          closeOnClickModal: false
        })
        .then(() => {
          let params = {
            id: row.id,
            operate: type,
            username: ''
          }
          this.$post('/request/tracing/source/operate', params, this.$GLOBAL.jsonConfig)
          .then(res => {
            // console.log(res)
            if (res.code === '00000') {
              this.$message({
                message: message,
                type: 'success',
                center: true
              });
              this.initList();
            } else {
              this.$message({
                message: res.message,
                type: 'error',
                center: true
              });
            }
          })
        })
      }
    }
  },
  components: {
    NavBar,
  }
};
</script>
<style lang="less" scoped>

  .content{

    .paddingContent{
      .ListMenu{
        .MenuBtnWrap{
          display: flex;
          justify-content: flex-end;
          .btn:last-child{
            margin-left: 0.2rem;
          }
        }
      }
      .tableWrap {
        width: 100%;
        height: calc(100% - 152px);
        overflow: auto;
        word-break: break-all;

        .goodsOperate{
          display: inline-block;
          img{
            width: 0.16rem;
          }
        }
        .goodsOperate:last-child{
          margin-left: 0.2rem;
        }


        @media (max-width: 768px) {
          height: calc(100% - 92px);
        }

        @media (max-width: 420px) {
          height: calc(100% - 112px);
        }
        @media (min-width: 769px) {
          .downShelf{
            width: 0.8rem;
            padding-left: 0.2rem;
            background:url('../../../assets/images/market/downShelf.png') no-repeat center left;
          }
          .onShelves{
            width: 0.8rem;
            padding-left: 0.2rem;
            background: url('../../../assets/images/market/onShelves.png') no-repeat center left;
          }
        }
      }
    }

    .propWrap{
      .icon-close{
        margin:10px;
      }
      .detailsContent{
        width: 100%;
        padding: 0.5rem;
        min-height: 0;
      }
    }

  }
  @media screen and (min-width: 769px) {
    .ListMenu{
      display: flex;
      justify-content: space-between;
      .searchForm{
        flex: 1;
        display: flex;
        justify-content: flex-start;
      }
      .MenuBtnWrap{
        flex: 1;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/market/memberGoods/memberGoodsList.vue